export {
  ANSI,
  isTTY,
  parseKey,
  type KeyAction,
} from "opencode-multi-account-core";
